var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssured(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23101 4.00598C1.82255 4.41444 1.82255 5.07667 2.23101 5.48513L6.2247 9.47882L7.70384 7.99967L3.71015 4.00598C3.3017 3.59753 2.63946 3.59753 2.23101 4.00598Z",
    fill: "#0067E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63935 6.96427C1.23089 7.37273 1.23089 8.03496 1.63935 8.44342L4.44973 11.2538L5.92887 9.77465L3.11849 6.96427C2.71004 6.55582 2.0478 6.55582 1.63935 6.96427Z",
    fill: "#0067E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9934 2.23101C11.5849 1.82255 10.9227 1.82255 10.5142 2.23101L6.52053 6.2247L7.99967 7.70384L11.9934 3.71015C12.4018 3.3017 12.4018 2.63946 11.9934 2.23101Z",
    fill: "#0067E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03508 1.63935C8.62662 1.23089 7.96438 1.23089 7.55593 1.63935L4.74555 4.44973L6.2247 5.92887L9.03508 3.11849C9.44353 2.71004 9.44353 2.0478 9.03508 1.63935Z",
    fill: "#0067E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7683 11.9934C14.1768 11.5849 14.1768 10.9227 13.7683 10.5142L9.77465 6.52053L8.2955 7.99967L12.2892 11.9934C12.6976 12.4018 13.3599 12.4018 13.7683 11.9934Z",
    fill: "#0067E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.36 9.03508C14.7685 8.62662 14.7685 7.96438 14.36 7.55593L11.5496 4.74555L10.0705 6.2247L12.8809 9.03508C13.2893 9.44353 13.9515 9.44353 14.36 9.03508Z",
    fill: "#0067E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00598 13.7683C4.41444 14.1768 5.07667 14.1768 5.48513 13.7683L9.47882 9.77465L7.99967 8.2955L4.00598 12.2892C3.59753 12.6976 3.59753 13.3599 4.00598 13.7683Z",
    fill: "#0067E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96427 14.36C7.37273 14.7685 8.03496 14.7685 8.44342 14.36L11.2538 11.5496L9.77465 10.0705L6.96427 12.8809C6.55582 13.2893 6.55582 13.9515 6.96427 14.36Z",
    fill: "#0067E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssured);
export default __webpack_public_path__ + "static/media/assured.0cbd4e681b7144c9d91d01a04d2ab055.svg";
export { ForwardRef as ReactComponent };